import { mapState } from 'vuex';

import { formMixin } from '@/mixins/form';
import { notificationsMixin } from './notifications';
import { tryParseInt } from '@/utils/number';

/**
 * Mixin zarządzania modelem
 *
 * @export
 * @param {string} moduleName - nazwa modułu
 * @param {Object} messages - treści notyfikacji
 * @param {string} [messages.formError] - treść notyfikacji o błędzie walidacji
 * @param {function} emptyModel - funkcja tworząca pusty model
 * @returns
 */
export function manageMixin(moduleName, messages, emptyModel) {
  return {
    mixins: [formMixin, notificationsMixin],
    data() {
      return {
        model: emptyModel()
      };
    },
    props: {
      // Boolean kontrolujący widoczność modala
      show: {
        type: Boolean,
        required: true,
        default: false
      },
      // Identyfikator edytowanej encji
      id: {
        type: Number,
        required: false,
        default: undefined
      }
    },
    methods: {
      // @vuese
      // Funkcja emituje event `close` do zamknięcia modalu
      close() {
        // Zamyka modal
        this.$emit('close');
      },
      // @vuese
      // Funkcja mapująca model przed zapisem
      prepareModel(model) {
        return model;
      },
      // @vuese
      // Funkcja waliduje formularz, i zapisuje/nadpisuje dane w bazie
      save() {
        if (!this.$schema.$validateAll().length) {
          const model = this.prepareModel(this.$schema.$getData());

          if (this.id) {
            // Emituje event do edytowania danych
            // @arg Zwalidowany model do edycji w bazie
            this.$emit('update', {
              id: tryParseInt(this.id),
              ...model
            });
          } else {
            // Emituje event do zapisu danych
            // @arg Zwalidowany model do utworzenia w bazie
            this.$emit('save', model);
          }
          this.close();
        } else {
          this.notifyError(messages.formError || 'messages.form.error');
        }
      },

      /**
       * Ustawia dane formularza
       */
      setData() {
        this.$schema.$setData(this.id ? this.stateData : emptyModel());
        this.$schema.$reset();
      }
    },
    computed: mapState({
      stateData: state => state[moduleName].data
    }),
    watch: {
      /**
       * Resetuje pola modala przed pokazaniem go
       *
       * @param {boolean} val
       */
      show(val) {
        if (val) {
          this.setData();
        }
      }
    }
  };
}
